import React, { useEffect } from 'react';

import { Dialog, TextField } from '@material-ui/core';
import PropTypes from 'prop-types';

import LogoCliqueRetire from '../../../../assets/images/LogoCliqueHorizontal.svg';
import { ButtonPrimary } from '../../../../shared/components';
import { useGetCliqueRetireCredentials } from '../../hooks/use-get-cliqueretire-credentials';
import { useSetCliqueRetireCredentials } from '../../hooks/use-set-cliqueretire-credentials';
import { BootstrapDialogTitle } from '../BootstrapDialogTitle';
import { DivActions, ContentModal } from '../styles';

export function ModalCliqueRetire({ open, handleClose, storeId }) {
  const { getCliqueRetireCredentials, credentials, setCredentials } =
    useGetCliqueRetireCredentials();
  const { setCliqueRetireCredentials } = useSetCliqueRetireCredentials();

  useEffect(() => {
    if (open) {
      getCliqueRetireCredentials(storeId);
    }
  }, [open]);

  return (
    <Dialog fullWidth={600} open={open} onClose={handleClose}>
      <BootstrapDialogTitle onClose={handleClose} logo={LogoCliqueRetire}>
        Linkar conta com Clique Retire
      </BootstrapDialogTitle>
      <ContentModal>
        <TextField
          id="apiKey"
          label="Chave da API *"
          variant="outlined"
          fullWidth
          value={credentials.apiKey}
          onChange={(e) =>
            setCredentials({ ...credentials, apiKey: e.target.value.trim() })
          }
        />
        <TextField
          id="apiId"
          label="ID da  API *"
          variant="outlined"
          fullWidth
          value={credentials.apiId}
          onChange={(e) =>
            setCredentials({
              ...credentials,
              apiId: e.target.value.trim(),
            })
          }
        />
      </ContentModal>
      <DivActions>
        <ButtonPrimary.Normal
          width="100%"
          label="LINKAR CONTA"
          onClick={async () => {
            await setCliqueRetireCredentials({ storeId, credentials });
            handleClose();
          }}
        />
      </DivActions>
    </Dialog>
  );
}

ModalCliqueRetire.propTypes = {
  storeId: PropTypes.string.isRequired,
  open: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
};
